import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import Progress from "./Progress";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useNavigate } from "react-router-dom";

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.displayMasters}`;
const spacePlaningUrl = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignments}`;

export default function MasterDialog(props) {
  const { open, handleClose, id, data, spacePlaningDate } = props;
  const [rowData, setRowData] = useState();
  const [error, setError] = useState();
  const gridRef = useRef();
  const [addedRows, setAddedRows] = useState([]);
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Sno.",
      valueGetter: "node.rowIndex + 1",
      maxWidth: 100,
    },
    {
      field: "layoutName",
      minWidth: 200,
    },
    {
      field: "product",
      minWidth: 202,
    },
    {
      field: "range1",
      minWidth: 250,
    },
    {
      field: "priceGroup",
      minWidth: 250,
    },
    {
      field: "front1",
      minWidth: 200,
    },
    {
      field: "carcass",
      minWidth: 250,
    },
    {
      field: "range2",
      minWidth: 250,
    },
    {
      field: "priceGroup2",
      minWidth: 250,
    },
    {
      field: "front2",
      minWidth: 200,
    },
    {
      field: "carcass2",
      minWidth: 250,
    },
    {
      field: "scheme",
      minWidth: 200,
    },
    {
      field: "handleConcept",
      minWidth: 200,
    },
    {
      field: "handle1",
      minWidth: 200,
    },
    {
      field: "handle2",
      minWidth: 200,
    },
    {
      field: "drawerAccFinish",
      minWidth: 200,
    },
    {
      field: "drawerType",
      minWidth: 200,
    },
    {
      field: "antiStpMat",
      minWidth: 200,
    },
    {
      field: "lightings",
      minWidth: 200,
    },
    {
      field: "sinkAccsseories",
      minWidth: 200,
    },
    {
      field: "workTops",
      minWidth: 200,
    },
    {
      field: "plinths",
      minWidth: 200,
    },
    {
      field: "uploadWinnerFile",
      minWidth: 200,
    },
    {
      field: "remarks",
      minWidth: 200,
    },
  ]);

  const addDisplayMaster = () => {
    navigate("/design-studio/display-master");
  };

  const loadDate = async () => {
    try {
      const list = await OAuthService.getList(url + "?size=1000");
      let displayMasters = list.data?._embedded?.displayMasters;
      setRowData(displayMasters);
    } catch (error) {
      setError(error.message);
      console.log(error);
    }
  };

  const onGridReady = useCallback((params) => {
    loadDate();
  }, []);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const handleSelected = async () => {
    function removeDuplicate(arr, prop){
      return arr.filter((obj, index, self) => index === self.findIndex(el => el[prop] === obj[prop]));
    }
    const merge = [...data.spacePlans, ...selectedRows]
    const unique = removeDuplicate(merge, 'srNo');
    data.spacePlans = unique
    data.isDsLifeCyclePassForNextState = false
    data.isDsStatusPassForNextState = false

    try {
      await OAuthService.putData(`${spacePlaningUrl}/${id}`, data);
      handleClose()
      spacePlaningDate()
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              DISPLAY MASTER
            </Typography>
            <IconButton onClick={handleClose}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Typography variant="subtitle1">Ground Floor</Typography>
          <div className="my-16" style={{ height: "400px" }}>
            <AgGridTable
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              gridRef={gridRef}
              onSelectionChanged={onSelectionChanged}
              // getContextMenuItems={getContextMenuItems}
              // rowSelection={"single"}
              // onRowValueChanged={onRowValueChanged}
              // onRowDoubleClicked={}
              // editType={"fullRow"}
            />
          </div>
          <div className="flex w-full justify-between">
          <Button
            variant="contained"
            color="warning"
            size="large"
            onClick={handleSelected}
          >
            Add Selected Item
          </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
